import React from 'react';
import {  Route, Routes } from 'react-router-dom';
import Register from '../register/register2'
import Password  from '../resetpassword/forgetpassword';
import ResetPassword  from '../resetpassword/resetpassword';
import CusLogin from '../adminlogin/cuslogin'
import AdminLogin from '../adminlogin/adminlogin'
function PublicRoutes() {
    return (
        <Routes>
            <Route path="/register" element={<Register/>} />
            <Route path="/forgetpassword" element={<Password/>} />
            <Route path="/resetpassword" element={<ResetPassword/>} />
            <Route path="/login" element={<CusLogin admin={false}/>} />
            <Route path="/" element={<CusLogin admin={false}/>} />
            <Route path="/adminlogin" element={<AdminLogin admin={true}/>} />
        </Routes>
    );
}

export default PublicRoutes;
